import type Backbone from 'backbone';
import type { IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';
import trackingGetProductsCount from '@/js/common/Domain/Service/tracking/trackingGetProductsCount';
import getSupplierBlocksPerDate from './getSupplierBlocksPerDate';
import trackingService from '../tracking';

interface IParamsForTrackingHotelSupplierPrices {
    tourCriteria: any;
    model: any;
    startSearchTime: number;
}

export default (
    foundTours: Backbone.Collection<IBackboneProduct>,
    params: IParamsForTrackingHotelSupplierPrices,
): void => {
    const { tourCriteria, model, startSearchTime } = params;

    if (!trackingGetProductsCount(foundTours).hotelOffersCount) {
        return;
    }

    trackingService.hotelSupplierPrices({
        tourCriteria,
        foundTours,
        timestamp: startSearchTime,
        productTypeByFilterCriteria: model.get('filterCriteria').get('productType'),
        supplierBlocksPerDate: getSupplierBlocksPerDate(foundTours),
    });
};
